// Emojis available for external visitor end screens, with the background colour each sets
export const completedScreenEmojis: { emoji: string, background: 'green' | 'red' | null }[] = [
    { emoji: '✅', background: 'green' },
    { emoji: '✔️', background: 'green' },
    { emoji: '👍', background: 'green' },
    { emoji: '😀', background: 'green' },
    { emoji: '🙂', background: 'green' },
    { emoji: '❌', background: 'red' },
    { emoji: '✖️', background: 'red' },
    { emoji: '👎', background: 'red' },
    { emoji: '🙁', background: 'red' },
    { emoji: '🛑', background: 'red' },
    { emoji: '⛔', background: 'red' },
    { emoji: '🚫', background: 'red' },
    { emoji: '🏆', background: null },
    { emoji: '🎉', background: null },
    { emoji: '⭐', background: null },
    { emoji: '😐', background: null },
    { emoji: '🙏', background: null },
    { emoji: '⚠️', background: null },
    { emoji: 'ℹ️', background: null },
    { emoji: '🍽️', background: null },
    { emoji: '🧼', background: null },
    { emoji: '🩺', background: null },
    { emoji: '🤒', background: null },
    { emoji: '📞', background: null },
]

// Returns the Tailwind background class for an emoji, or null for the default card background
export function getCompletedScreenBackgroundClass(emoji: string | null | undefined): string | null {
    const match = completedScreenEmojis.find((option) => option.emoji === emoji)
    if (match && match.background === 'green') return 'bg-green-100'
    if (match && match.background === 'red') return 'bg-red-100'
    return null
}
